export enum ModelStatus {
  DRAFT = 'DRAFT',
  RELEASED = 'RELEASED',
  RELEASING = 'RELEASING'
}
